import { Stack, styled } from '@mui/material';

export const SkeletonLoader = styled(Stack)(({ theme }) => ({
    width: '100%',
    padding: theme.spacing(4),
}));
